import { render } from "./Dashboard.vue?vue&type=template&id=25a5ba4a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/efakturastat.dev.oneit.rs/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/views/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25a5ba4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25a5ba4a', __exports__)) {
    console.log('reload')
    api.reload('25a5ba4a', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=25a5ba4a", () => {
    console.log('re-render')
    api.rerender('25a5ba4a', render)
  })

}


export default __exports__